/* eslint-disable import/extensions */
/* eslint-disable no-console */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable object-curly-newline */
/* eslint-disable camelcase */
import React, {
 useContext, useState, useMemo, useEffect, useRef, useCallback
} from 'react'
import Heading2 from '@apps/components/Typography/Heading2'
import { useHistory, useLocation } from 'react-router-dom'
import { APPLICATION_STATE, ApplicationContext, setLandingLogicLoader } from '@apps/contexts/ApplicationContext'
import {
  setSimType,
  setSimNumber,
  updateSimSelectionState
} from '@apps/redux/features/SimSelectionSlice'
import SimSelectionChangeHandlers, {
  SIM_SELECTION_EVENTS
} from '@apps/utils/ChangeHandlers/SimSelectionChangeHandlers'
import { getBySlug, getById } from '@apps/utils/contentful'
import {
  getMissingSimSelectionContent,
  getSimSelectionPageContent,
  getSimSelectionSlugValue
} from '@apps/utils/simSelectionContent'
import Sites from '@sites/index'
import ConsumerActivationPaths from '@sites/consumer/activation/ConsumerActivationPaths'
import DealerActivationPaths from '@sites/dealer/activation/DealerActivationPaths'
import {
  CONSUMER_SIM_OPTIONS,
  SIM_OPTIONS,
  ANALYTICS_EVENT_TYPES,
  PAGE_NUMBER
} from '@apps/utils/constants'
import Modal from '@apps/components/Modal'
import { useDispatch, useSelector } from 'react-redux'
import { setPageAnalytics } from '@apps/utils/Analytics'
import { currencyFormatter } from '@apps/utils/CurrencyFormatter'
import CheckoutLayout from '@apps/components/CheckoutLayout'
import {
  Card,
  Divider,
  Spacer,
  Typography
} from '@telus/koodo-ui-kit'
import SimSelectionDetails from '@/apps/components/SimSelectionDetails'
import SimSelectionFooter from '@/apps/components/SimSelectionFooter'
import SimSelectionRadioCardGroup, {
  SIM_CARD_IDS
} from '@/apps/components/SimSelectionRadioCardGroup'
import Alert from '@/apps/components/Alert'
import LegacyButton from '@/apps/components/Button'
import useTagManagerInfo from '../../_engine/hooks/useTagManagerInfo'

const MISSING_CONTENT_HEADING_TOKENS = {
  color: '#000000',
  fontName: 'StagSans',
  fontSize: 24,
  fontWeight: 700,
  letterSpacing: 0,
  lineHeight: '32px'
}
const BODY_COPY_TOKENS = {
  color: '#000000',
  fontSize: 14,
  fontWeight: 400,
  letterSpacing: 0,
  lineHeight: '20px'
}
const BODY_BOLD_TOKENS = {
  color: '#000000',
  fontName: 'StagSans',
  fontSize: 14,
  fontWeight: 700,
  letterSpacing: 0,
  lineHeight: '20px'
}

const DEALER_EID_REQUIRED_ERROR_FALLBACK = {
  en: 'Missing EID Number',
  fr: 'Numéro EID manquant'
}
// Matches the existing dealer EID input limit used in DealerESIMCompatibility.
const DEALER_EID_LENGTH = 32

export const getInitialSimCardIdFromSelection = ({
  isDealer,
  simType,
  currentPageModule
} = {}) => {
  if (isDealer) {
    if (simType === SIM_OPTIONS.E_SIM) return SIM_CARD_IDS.ESIM
    // Dealers sell physical SIMs through their existing process. Treat a
    // restored legacy purchase selection as a SIM the customer already has.
    if (simType === SIM_OPTIONS.P_SIM) return SIM_CARD_IDS.HAS_PHYSICAL
    // Fresh entry (no SIM type recorded yet) defaults to eSIM.
    if (!simType) return SIM_CARD_IDS.ESIM
    return SIM_CARD_IDS.HAS_PHYSICAL
  }

  if (currentPageModule === CONSUMER_SIM_OPTIONS.NEW_SIM) {
    return simType === SIM_OPTIONS.P_SIM ? SIM_CARD_IDS.BUY_PHYSICAL : SIM_CARD_IDS.ESIM
  }

  if (!currentPageModule) {
    if (simType === SIM_OPTIONS.E_SIM) return SIM_CARD_IDS.ESIM
    if (simType === SIM_OPTIONS.P_SIM) return SIM_CARD_IDS.BUY_PHYSICAL
    // Fresh entry (no SIM type recorded yet) defaults to eSIM.
    if (!simType) return SIM_CARD_IDS.ESIM
  }

  return SIM_CARD_IDS.HAS_PHYSICAL
}

export const getSimSelectionRadioItems = ({
  isDealer,
  textContent = {},
  formatESimOptionTitle = (title) => title,
  formatPSimOptionTitle = (title) => title
} = {}) => {
  const items = [
    {
      id: SIM_CARD_IDS.ESIM,
      title: formatESimOptionTitle(textContent.newESimOption),
      journeyType: isDealer ? SIM_OPTIONS.E_SIM : CONSUMER_SIM_OPTIONS.NEW_SIM
    },
    {
      id: SIM_CARD_IDS.HAS_PHYSICAL,
      title: textContent.havePhysicalSimOption,
      journeyType: isDealer ? SIM_OPTIONS.H_SIM : CONSUMER_SIM_OPTIONS.HAVE_SIM
    }
  ]

  if (!isDealer) {
    items.push({
      id: SIM_CARD_IDS.BUY_PHYSICAL,
      title: formatPSimOptionTitle(textContent.buyPhysicalSimOption),
      journeyType: SIM_OPTIONS.P_SIM
    })
  }

  return items
}

const normalizeValidationMessage = (value) => `${value || ''}`.replace(/\s+/g, ' ').trim().toLowerCase()

export const getDealerEIDRequiredError = ({
  requiredError,
  invalidError,
  language
} = {}) => {
  const normalizedRequiredError = normalizeValidationMessage(requiredError)
  const normalizedInvalidError = normalizeValidationMessage(invalidError)

  if (normalizedRequiredError && normalizedRequiredError !== normalizedInvalidError) {
    return requiredError
  }

  return DEALER_EID_REQUIRED_ERROR_FALLBACK[language] || DEALER_EID_REQUIRED_ERROR_FALLBACK.en
}

const getNormalizedDealerEIDValue = (eidValue) => `${eidValue || ''}`.trim()

const getValidDealerEIDValue = (eidValue) => {
  const normalizedEIDValue = getNormalizedDealerEIDValue(eidValue)
  return normalizedEIDValue.length === DEALER_EID_LENGTH ? normalizedEIDValue : ''
}

export const getDealerEIDValidationError = ({
  eidValue,
  requiredError,
  invalidError,
  language
} = {}) => {
  const normalizedEIDValue = getNormalizedDealerEIDValue(eidValue)
  if (getValidDealerEIDValue(normalizedEIDValue)) return ''
  return normalizedEIDValue
    ? invalidError
    : getDealerEIDRequiredError({ requiredError, invalidError, language })
}

const SimSelectionPage = () => {
  const {
    userType,
    quote: { quoteInfo },
    user: { email, accountInfo }
  } = useSelector((state) => state.common)
  const { pageContent, featureFlags } = useSelector((state) => state.common.content)
  const simSelectionState = useSelector((state) => state.simSelectionPage)
  
  const {
    imeiChecked,
    imeiCompatible,
    selectSimType,
    simNumber,
    simError,
    isComplete
  } = simSelectionState

  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()

  const dealerActivationPaths = new DealerActivationPaths()
  const consumerActivationPaths = new ConsumerActivationPaths()

  const [showESimCompatibilityWarning, setShowESimCompatibilityWarning] = useState(false)
  const [nextStepLoading, setNextStepLoading] = useState(false)
  const [dealerEIDValue, setDealerEIDValue] = useState('')
  const [dealerEIDError, setDealerEIDError] = useState('')
  const { simType, cost: simCost } = selectSimType

  const {
    [APPLICATION_STATE.CURRENT_LANGUAGE]: language,
    [APPLICATION_STATE.SERVICES]: brandServices,
    [APPLICATION_STATE.CURRENT_REGION]: region,
    [APPLICATION_STATE.IDENTITY]: identity
  } = useContext(ApplicationContext)

  const { setPatchQuote, isSimValid } = brandServices

  const isSimSelectionContentPending = !Array.isArray(pageContent)
    || pageContent.length === 0
    || !language
    || !userType

  const missingSimSelectionContent = useMemo(() => {
    return getMissingSimSelectionContent(pageContent, language, userType)
  }, [pageContent, language, userType])

  const hasMissingSimSelectionContent = missingSimSelectionContent.length > 0

  const simSelectionPageContent = useMemo(() => {
    if (isSimSelectionContentPending || hasMissingSimSelectionContent) return {}
    return getSimSelectionPageContent(pageContent, language, userType)
  }, [
    pageContent,
    language,
    userType,
    isSimSelectionContentPending,
    hasMissingSimSelectionContent
  ])

  const { shortTextFields } = simSelectionPageContent
  const enableProceedWithoutCheckingESim = featureFlags && featureFlags[0]?.enableProceedWithoutCheckingESim
  const quoteSimType = quoteInfo?.SimInformation?.simType

  const textContent = useMemo(() => {
    if (isSimSelectionContentPending || !shortTextFields || hasMissingSimSelectionContent) return {}
    const commonElements = getById(pageContent, 'commonElements')?.[language]
    const commonShortTextFields = commonElements?.shortTextFields
    return {
      simSectionHeading: getBySlug(shortTextFields, 'simSectionHeading')?.value,
      nextStepPSIMLabel: getBySlug(shortTextFields, 'nextStepLabel')?.value,
      continueButtonLabel: getBySlug(commonShortTextFields, 'continueButtonLabel')?.value,
      previousStepLabel: getSimSelectionSlugValue(shortTextFields, 'previousStepLabel', userType),
      haveSim: getBySlug(shortTextFields, 'haveSim')?.value,
      newSim: getBySlug(shortTextFields, 'newSim')?.value,
      // haveSimHeading: getBySlug(shortTextFields, 'haveSimHeading')?.value,
      simSelectionRadioHeading:
        getSimSelectionSlugValue(shortTextFields, 'simSelectionRadioHeading', userType),
      nextStepESIMLink: getBySlug(shortTextFields, 'nextStepESIMLink')?.value,
      nextStepESIMLabel: getBySlug(shortTextFields, 'nextStepESIMLabel')?.value,
      compatibilityWarningHeader: getBySlug(shortTextFields, 'compatibilityWarningHeader')?.value,
      compatibilityWarningTitle: getBySlug(shortTextFields, 'compatibilityWarningTitle')?.value,
      compatibilityWarningMessage: getBySlug(shortTextFields, 'compatibilityWarningMessage')?.value,
      buyPhysicalSIM: getBySlug(shortTextFields, 'buyPhysicalSIM')?.value,
      proceedAnyway: getBySlug(shortTextFields, 'proceedAnyway')?.value,
      simRequiredError: getBySlug(shortTextFields, 'simRequiredError')?.value,
      simLengthError: getBySlug(shortTextFields, 'simLengthError')?.value,
      simUnavailableError: getBySlug(shortTextFields, 'simUnavailableError')?.value,
      eSimCost: getSimSelectionSlugValue(shortTextFields, 'eSimCost', userType),
      pSimCost: getSimSelectionSlugValue(shortTextFields, 'pSimCost', userType),
      newESimOption: getSimSelectionSlugValue(shortTextFields, 'newESimOption', userType),
      havePhysicalSimOption:
        getSimSelectionSlugValue(shortTextFields, 'havePhysicalSimOption', userType),
      buyPhysicalSimOption: userType === Sites.dealer
        ? undefined
        : getSimSelectionSlugValue(shortTextFields, 'buyPhysicalSimOption', userType),
      eidRequiredError: getSimSelectionSlugValue(shortTextFields, 'eidRequiredError', userType),
      eidInvalidError: getSimSelectionSlugValue(shortTextFields, 'eidInvalidError', userType)
    }
  }, [
    shortTextFields,
    pageContent,
    language,
    userType,
    isSimSelectionContentPending,
    hasMissingSimSelectionContent
  ])

  useEffect(() => {
    if (dealerEIDError) {
      setDealerEIDError(getDealerEIDValidationError({
        eidValue: dealerEIDValue,
        requiredError: textContent?.eidRequiredError,
        invalidError: textContent?.eidInvalidError,
        language
      }))
    }
  }, [language])

  const {
 simRequiredError, simLengthError, simUnavailableError, eSimCost, pSimCost 
} = textContent

  const tagManagerInfo = useTagManagerInfo()

  const pushClickAnalytics = ({ click_text, journey_type, event_type, event_click = ANALYTICS_EVENT_TYPES.CLICK }={}) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(
      setPageAnalytics(location, 'click', region, language, {
        ...tagManagerInfo,
        click_text,
        journey_type
      }, event_type, event_click)
    )
  }

  const pushTagManagerToDataLayer = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(
      setPageAnalytics(location, 'form', region, language, tagManagerInfo)
    )
  }

  useEffect(() => {
    if (userType === Sites.dealer && identity) {
      setTimeout(() => {
        pushTagManagerToDataLayer()
      }, 0)
    }
  }, [region, language, identity])

  useEffect(() => {
    if (userType === Sites.consumer) {
      setTimeout(() => {
        pushTagManagerToDataLayer()
      }, 0)
    }
  }, [region, language])

  useEffect(() => {
    if (simError && simError !== '') {
      pushTagManagerToDataLayer()
    }
  }, [simError])

  useEffect(() => {
    if (hasMissingSimSelectionContent) {
      // Make Contentful setup issues visible even when the dev error overlay
      // fails to resolve source-map stack frames.
      console.error(
        '[KPRE] Missing dealer SIM selection Contentful content:',
        missingSimSelectionContent
      )
    }
  }, [hasMissingSimSelectionContent, missingSimSelectionContent])

  const parsePrice = (price) => {
    const parsed = parseFloat(price)
    return Number.isNaN(parsed) ? 0 : parsed
  }

  const eSimPrice = parsePrice(eSimCost)
  const pSimPrice = parsePrice(pSimCost)

  const formatSimPrice = useCallback((price) => {
    return currencyFormatter(price, language).replace(/([.,]00)(?=\s?\$|$)/, '')
  }, [language])

  const formatESimOptionTitle = useCallback((title) => {
    const eSimTitle = `${title || ''}`.trim()
    if (!eSimTitle) return ''
    if (/\(\s*\+\s*(?:\$|\d)/.test(eSimTitle)) return eSimTitle
    return `${eSimTitle} ( +${formatSimPrice(eSimPrice)})`
  }, [eSimPrice, formatSimPrice])

  const formatPSimOptionTitle = useCallback((title) => {
    const pSimTitle = `${title || ''}`.trim()
    if (!pSimTitle) return ''
    if (/\(\s*\+\s*(?:\$|\d)/.test(pSimTitle)) return pSimTitle
    return `${pSimTitle} ( +${formatSimPrice(pSimPrice)})`
  }, [pSimPrice, formatSimPrice])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    const unblock = history.block( (location, action) => {
      if (action === 'pop' || action === 'POP') {
        return false
      }

      return () => {
        unblock()
      }
    })
  }, [history])

  const simRef = useRef(null)

  const isDealer = useMemo(() => {
    return userType === Sites.dealer
  }, [userType])

  const radioItems = useMemo(() => {
    return getSimSelectionRadioItems({
      isDealer,
      textContent,
      formatESimOptionTitle,
      formatPSimOptionTitle
    })
  }, [isDealer, textContent, formatESimOptionTitle, formatPSimOptionTitle])

  const getInitialSimCardId = () => {
    return getInitialSimCardIdFromSelection({
      isDealer,
      simType,
      currentPageModule: selectSimType.currentPageModule
    })
  }

  const [selectedSimCardId, setSelectedSimCardId] = useState(getInitialSimCardId)

  const selectedSimOption = useMemo(() => {
    const selectedItem = radioItems.find((item) => item.id === selectedSimCardId)

    if (isDealer) {
      return {
        name: selectedItem?.title,
        value: selectedSimCardId === SIM_CARD_IDS.ESIM ? SIM_OPTIONS.E_SIM : SIM_OPTIONS.H_SIM,
        simType: selectedSimCardId === SIM_CARD_IDS.ESIM ? SIM_OPTIONS.E_SIM : SIM_OPTIONS.H_SIM
      }
    }

    if (selectedSimCardId === SIM_CARD_IDS.ESIM) {
      return {
        name: selectedItem?.title,
        value: CONSUMER_SIM_OPTIONS.NEW_SIM,
        simType: SIM_OPTIONS.E_SIM
      }
    }

    if (selectedSimCardId === SIM_CARD_IDS.BUY_PHYSICAL) {
      return {
        name: selectedItem?.title,
        value: CONSUMER_SIM_OPTIONS.NEW_SIM,
        simType: SIM_OPTIONS.P_SIM
      }
    }

    return {
      name: selectedItem?.title,
      value: CONSUMER_SIM_OPTIONS.HAVE_SIM,
      simType: SIM_OPTIONS.H_SIM
    }
  }, [isDealer, radioItems, selectedSimCardId])

  const selectedPageOption = selectedSimOption?.value
  const selectedOptionSimType = selectedSimOption?.simType
  const isConsumerESimSelected =
    !isDealer &&
    selectedSimCardId === SIM_CARD_IDS.ESIM &&
    selectedPageOption === CONSUMER_SIM_OPTIONS.NEW_SIM

  const updateSimSelectionStore = (newState) => {
    dispatch(updateSimSelectionState(newState))
  }

  const resetSimSelection = (simTypeSelected, cost, pageModule, additionalState = {}) => {
    if (pageModule === CONSUMER_SIM_OPTIONS.HAVE_SIM) simTypeSelected = CONSUMER_SIM_OPTIONS.HAVE_SIM
    updateSimSelectionStore({
      selectSimType: {
        ...simSelectionState.selectSimType,
        currentPageModule: pageModule,
        simType: simTypeSelected,
        cost
      },
      imei: '',
      imeiChecked: false,
      imeiCompatible: false,
      simError: simNumber ? simError : '',
      ...additionalState
    })
  }

  const resetPSimDetails = (simOption) => {
    if (simOption === SIM_OPTIONS.E_SIM) {
      updateSimSelectionStore({
        simNumber: '',
        simError: ''
      })
    }
  }

  // "I already have a SIM card": the customer supplies their own SIM, so there
  // is nothing to charge. resetSimSelection rewrites the type to HAVE_SIM for
  // this page module — the cost has to follow, otherwise the order summary
  // adds the pSIM price on top of the plan.
  const resetConsumerPSIMCheck = (pageOption) => {
    resetSimSelection(SIM_OPTIONS.P_SIM, 0, pageOption)
  }
  const resetConsumerESIMCheck = (currentSimType, currentSimCost, pageOption) => {
    resetSimSelection(currentSimType, currentSimCost, pageOption)
  }

  const resetDealerEIDState = () => {
    setDealerEIDValue('')
    setDealerEIDError('')
  }

  const resetDealerPSIMCheck = (pageOption) => {
    updateSimSelectionStore({
      eid: '',
      // Keep only the validated state (null = validation succeeded) for an
      // already-entered SIM so the success check mark survives switching
      // between eSIM and Have SIM; error strings are cleared as before.
      simError: simNumber && simError === null ? null : '',
      selectSimType: {
        currentPageModule: pageOption,
        simType: SIM_OPTIONS.H_SIM,
        // Customer-supplied SIM — no SIM charge.
        cost: 0
      }
    })
  }

  const resetDealerESIMCheck = (pageOption) => {
    resetSimSelection(SIM_OPTIONS.E_SIM, eSimPrice, pageOption)
  }

  useEffect(() => {
    const pageOption = selectedPageOption
    if (pageOption) {
      if (isDealer) {
        if (selectedSimCardId === SIM_CARD_IDS.HAS_PHYSICAL) {
          resetDealerEIDState()
          resetDealerPSIMCheck(pageOption)
        } else {
          resetDealerESIMCheck(pageOption)
        }
      } else if (selectedSimCardId === SIM_CARD_IDS.HAS_PHYSICAL) {
        resetConsumerPSIMCheck(pageOption)
      } else if (selectedSimCardId === SIM_CARD_IDS.BUY_PHYSICAL) {
        resetConsumerESIMCheck(SIM_OPTIONS.P_SIM, pSimPrice, pageOption)
      } else {
        resetConsumerESIMCheck(SIM_OPTIONS.E_SIM, eSimPrice, pageOption)
      }
    }
  }, [selectedSimCardId, selectedPageOption, userType, eSimPrice, pSimPrice])

  useEffect(() => {
    if(isDealer && quoteSimType  === SIM_OPTIONS.E_SIM.toUpperCase()) {
      setSelectedSimCardId(SIM_CARD_IDS.ESIM)
    }
  }, [isDealer, quoteSimType])

  const handleSimBlur = async (setLoading) => {
    const errors = {
      simRequiredError,
      simLengthError,
      simUnavailableError
    }
    const simResult = await SimSelectionChangeHandlers[SIM_SELECTION_EVENTS.SIM].onBlur(
      simSelectionState,
      isSimValid,
      setLoading,
      errors,
      updateSimSelectionStore
    )
    if (simResult) {
      return true
    }
    return false
  }

  const getPlainSimNumber = (simNumberText) => {
    if (!simNumberText) return ''
    return simNumberText.replace(/ - /g, '')
  }

  const updateQuote = async (val) => {
    const input = { email }
    const quoteSimType = val || simType
    const validDealerEIDValue = getValidDealerEIDValue(dealerEIDValue)
    if ([SIM_OPTIONS.H_SIM, SIM_OPTIONS.P_SIM].includes(quoteSimType) && !val) {
      input.simType = 'HAVESIM'
      input.simNumber = getPlainSimNumber(simNumber)
    } else {
      input.simType = 'ESIM'
      if (isDealer && validDealerEIDValue) {
        input.eid = validDealerEIDValue
      }
    }
    try {
      const response = await setPatchQuote(input)
      return response
    } catch (err) {
      console.log('ERROR', err)
      return err
    }
  }

  const proceedToNextStep = async (val) => {
    try {
      setLandingLogicLoader('IN_PROGRESS')
      if (isComplete) {
        const response = await updateQuote(val)
        const nextPagePath = isDealer
          ? dealerActivationPaths.ChooseNumber
          : consumerActivationPaths.ChooseNumber
  
        const splashPagePath = isDealer
          ? dealerActivationPaths.Splash
          : consumerActivationPaths.Splash
  
        resetPSimDetails(simType)
  
        if (response?.data?.accountId) {
          setLandingLogicLoader(false)
          history.push(nextPagePath)
        } else {
          setLandingLogicLoader(false)
          history.push(splashPagePath)
        }
      } else {
        let topError
  
        if ((await handleSimBlur(() => {})) && !topError) {
          topError = simRef
        }
  
        if (topError && topError?.current) {
          topError.current.scrollIntoView({
            behavior: 'smooth'
          })
        }
      }
    } finally {
      setLandingLogicLoader(false)
    }
  }

  const getPreviousStepLink = () => {
    return isDealer ? dealerActivationPaths.AccountSetup : consumerActivationPaths.AccountSetup
  }

  const handleNextStepClick = async () => {
    const haveSimValue = selectedPageOption
    const isBuyingPhysicalSim = selectedSimCardId === SIM_CARD_IDS.BUY_PHYSICAL

    if (isBuyingPhysicalSim) {
      return
    }

    const dealerEIDValidationError = isDealer && selectedPageOption === SIM_OPTIONS.E_SIM
      ? getDealerEIDValidationError({
        eidValue: dealerEIDValue,
        requiredError: textContent?.eidRequiredError,
        invalidError: textContent?.eidInvalidError,
        language
      })
      : ''

    if (dealerEIDValidationError) {
      setDealerEIDError(dealerEIDValidationError)
      return
    }

    setDealerEIDError('')
    setNextStepLoading(true)

    try {
      if (isConsumerESimSelected) {
        if (!imeiChecked) {
          setShowESimCompatibilityWarning(true)
        } else {
          await proceedToNextStep()
        }
      } else if (
        haveSimValue === CONSUMER_SIM_OPTIONS.HAVE_SIM ||
        haveSimValue === SIM_OPTIONS.H_SIM ||
        haveSimValue === SIM_OPTIONS.P_SIM
      ) {
        const hasError = await handleSimBlur(setNextStepLoading)
        if (!hasError) {
          await proceedToNextStep()
        }
      } else {
        await proceedToNextStep()
      }
    } finally {
      setNextStepLoading(false)
    }
  }

  const handleRadioSelectionClick = (value) => {
    setSelectedSimCardId(value)
    setDealerEIDError('')
  }

  const handleDealerEIDValueChange = useCallback((value) => {
    setDealerEIDValue(value)
    if (dealerEIDError) setDealerEIDError('')
  }, [dealerEIDError])

  const getNextStepLabel = () => {
    return textContent?.continueButtonLabel || 'Continue'
  }

  const getNextStepIsTextButton = () => {
    return false
  }

  const getNextStepIsHidden = () => {
    if (selectedSimCardId === SIM_CARD_IDS.BUY_PHYSICAL) {
      return true
    }
    if (isDealer) {
      return false
    }
    if (isConsumerESimSelected) {
      return true
    }
    return (
      !enableProceedWithoutCheckingESim &&
      selectedSimCardId === SIM_CARD_IDS.ESIM &&
      selectedPageOption === CONSUMER_SIM_OPTIONS.NEW_SIM &&
      (simType !== SIM_OPTIONS.E_SIM || (simType === SIM_OPTIONS.E_SIM && !imeiCompatible))
    )
  }

  const closeWarningModal = () => {
    setShowESimCompatibilityWarning(false)
  }

  const selectBuyPhysicalSim = () => {
    closeWarningModal()
    setSelectedSimCardId(SIM_CARD_IDS.BUY_PHYSICAL)
    updateSimSelectionStore({
      selectSimType: {
        ...selectSimType,
        currentPageModule: CONSUMER_SIM_OPTIONS.NEW_SIM,
        simType: SIM_OPTIONS.P_SIM,
        cost: pSimPrice
      }
    })
  }

  const handleBuySim = () => {
    pushClickAnalytics({ click_text: textContent?.buyPhysicalSIM, journey_type:'pSIM', event_type: 'Buy a physical sim' })
    selectBuyPhysicalSim()
  }

  const handleProceedWithESim = () => {
    pushClickAnalytics({ click_text: textContent?.proceedAnyway, journey_type: 'eSIM', event_type: 'Proceed with eSIM' })
    if(simNumber) {
      dispatch(setSimNumber(''))
    }
    setSelectedSimCardId(SIM_CARD_IDS.ESIM)
    dispatch(
      setSimType({
        simType: SIM_OPTIONS.E_SIM,
        cost: eSimPrice
      })
    )
    closeWarningModal()
    proceedToNextStep(SIM_OPTIONS.E_SIM)
  }

  const handleCompatibleESimContinue = () => {
    proceedToNextStep(SIM_OPTIONS.E_SIM)
  }

  if (isSimSelectionContentPending) {
    return null
  }

  if (hasMissingSimSelectionContent) {
    return (
      <div className="mx-auto max-w-4xl p-6 text-black" role="alert">
        <div className="mb-4">
          <Typography
            block
            heading="h1"
            variant={{ size: 24, bold: true, color: '#000000' }}
            tokens={MISSING_CONTENT_HEADING_TOKENS}
          >
            Missing dealer SIM selection Contentful content
          </Typography>
        </div>
        <div className="mb-4">
          <Typography
            block
            tag="p"
            variant={{ size: 14, color: '#000000' }}
            tokens={BODY_COPY_TOKENS}
          >
            Add or publish the following Contentful entries for the dealer SIM selection page.
          </Typography>
        </div>
        <ul className="list-disc pl-6">
          {missingSimSelectionContent.map((item) => (
            <li key={`${item.type}-${item.key}`}>
              <Typography
                block
                tag="span"
                variant={{ size: 14, color: '#000000' }}
                tokens={BODY_COPY_TOKENS}
              >
                {item.pageId ? `${item.pageId}: ` : ''}
                {item.type}
                {' '}
                <Typography
                  tag="strong"
                  variant={{ size: 14, bold: true, color: '#000000' }}
                  tokens={BODY_BOLD_TOKENS}
                >
                  {item.key}
                </Typography>
              </Typography>
            </li>
          ))}
        </ul>
      </div>
    )
  }

  return (
    <CheckoutLayout
      heading={
        <Heading2 className="mt-6 sm:mt-10 max-w-2xl">
          {textContent?.simSectionHeading}
        </Heading2>
      }
      activeStepIndex={PAGE_NUMBER.SIM_SELECTION}
    >
      <Card variant={{ padding: 'intermediate', borderRadius: 'large' }}>
        <SimSelectionRadioCardGroup
          onChange={handleRadioSelectionClick}
          heading={textContent.simSelectionRadioHeading}
          items={radioItems}
          checkedId={selectedSimCardId}
        />
        <Spacer space={4} />
        <Divider />
        <Spacer space={3} />
        <SimSelectionDetails
          userType={userType}
          simSelection={selectedPageOption}
          selectedSimType={selectedOptionSimType}
          autoLookupIMEI={isConsumerESimSelected}
          onESimContinue={handleCompatibleESimContinue}
          onChoosePSim={selectBuyPhysicalSim}
          eSimContinueLabel={textContent?.continueButtonLabel || 'Continue'}
          eSimContinueTestId="sim-selection"
          dealerEIDValue={dealerEIDValue}
          dealerEIDError={dealerEIDError}
          onDealerEIDValueChange={handleDealerEIDValueChange}
          simRef={simRef}
        />
        {!isConsumerESimSelected && !getNextStepIsHidden() && (
          <div className="mt-6">
            <SimSelectionFooter
              previousStepLabel=""
              previousStepLink={getPreviousStepLink()}
              nextStepLabel={getNextStepLabel()}
              nextStepTextButton={getNextStepIsTextButton()}
              onNextStepClick={handleNextStepClick}
              dataTestid={(selectedPageOption === CONSUMER_SIM_OPTIONS.NEW_SIM && !imeiCompatible) ? 'proceed-with-esim' : 'sim-selection'}
              nextStepLoading={nextStepLoading}
              compactSpacing
            />
          </div>
        )}
      </Card>
      <Modal
        isOpen={showESimCompatibilityWarning}
        closeModal={closeWarningModal}
        title={textContent?.compatibilityWarningHeader}
      >
        <div className="text-black">
          <Alert
            header={textContent.compatibilityWarningTitle}
            message={(
              <Typography
                tag="span"
                variant={{ size: 14, color: '#000000' }}
                tokens={BODY_COPY_TOKENS}
              >
                {textContent?.compatibilityWarningMessage}
              </Typography>
            )}
          />
          <div className="flex flex-col sm:flex-row justify-between space-y-4 sm:space-y-0 sm:space-x-8">
            <LegacyButton
              type="button"
              label={textContent?.buyPhysicalSIM}
              className="w-full rounded-md"
              onClick={handleBuySim}
              testId="buy-physical-sim"
              outlined
            />
            <LegacyButton
              type="button"
              onClick={handleProceedWithESim}
              label={textContent?.proceedAnyway}
              className="w-full rounded-md"
              testId="proceed-anyway"
            />
          </div>
        </div>
      </Modal>
    </CheckoutLayout>
  )
}

export default SimSelectionPage
